import React from 'react'
import Image from 'next/image'
import { Header2, Header3, Text } from '../../styles/Components'
import { gsColors as c } from '../../styles/Variables'
import styled from '@emotion/styled'
import { mq } from '../../helpers'
import StepOneImg from '../../../public/how-it-works/step_one.webp'
import StepTwoImg from '../../../public/how-it-works/step_two.webp'
import StepThreeImg from '../../../public/how-it-works/step_three.webp'
import StepFourImg from '../../../public/how-it-works/step_final.webp'

const steps = [
  {
    number: '01',
    id: 'step-1',
    title: 'Select a Service',
    body: 'Blowouts, makeup, full glam, nails, and more. Pick your look and book in minutes. Not sure? We\u2019ll help you figure it out.\n\nSame-day service available.',
    image: StepOneImg,
    alt: 'Glamsquad app screen showing in-home beauty services to choose from: blowout, makeup, nails, and more',
    objectFit: 'cover',
  },
  {
    number: '02',
    id: 'step-2',
    title: 'Choose date, time, location',
    body: 'Pick a time that works for you and tell us where to show up \u2014 we come to you, on your schedule.',
    image: StepTwoImg,
    alt: 'Glamsquad app screen for selecting appointment date, time, and home service location',
    objectFit: 'cover',
  },
  {
    number: '03',
    id: 'step-3',
    title: 'Match with top-tier beauty pros',
    body: 'Get paired with a vetted, certified pro who specializes in exactly what you need. No guessing, no settling \u2014 just someone who gets your vision.',
    image: StepThreeImg,
    alt: 'Glamsquad app showing vetted hair stylists, makeup artists, and nail techs available to book',
    objectFit: 'cover',
  },
  {
    number: '04',
    id: 'step-4',
    title: 'Sit back and get glam',
    body: 'Your only job? Enjoy every second. Your pro handles the rest \u2014 you just show up and glow up.',
    image: StepFourImg,
    alt: 'Client relaxing during an in-home Glamsquad beauty appointment',
    objectFit: 'cover',
  },
]

const StepsWrapper = styled.section`
  width: 100%;
  max-width: 1600px;
  display: flex;
  flex-direction: column;

  ${mq('max', '768px')} {
    padding: 0;
  }
`

const StepRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;

  ${mq('max', '768px')} {
    flex-direction: column;
  }
`

const StepTextColumn = styled.div`
  width: 40%;
  display: flex;
  flex-direction: column;
  padding-left: 88px;

  ${mq('max', '768px')} {
    width: 100%;
    padding-left: 0;
  }
`

const Connector = styled.div`
  width: 2px;
  height: 114px;
  background-color: #C8C8CC;

  ${mq('max', '768px')} {
    display: none;
  }
`

const StepText = styled.div`
  padding: 68px 0;
  display: flex;
  flex-direction: column;

  ${mq('max', '768px')} {
    padding: 48px 16px 24px;
  }
`

const StepImage = styled.div`
  width: 50%;
  margin-left: auto;
  position: relative;
  aspect-ratio: 720 / 590;
  overflow: hidden;

  ${mq('max', '768px')} {
    width: 100%;
  }
`

const Steps = () => (
  <StepsWrapper>
    {steps.map((step, i) => (
      <StepRow key={step.number} id={step.id}>
        <StepTextColumn>
          {i > 0 && <Connector />}
          <StepText>
            <Header3 color={c.cobalt} spacing={2.64} margin="0 0 8px 0">
              {step.number}
            </Header3>
            <Header2 fontSize={32} margin="0 0 20px 0">
              {step.title}
            </Header2>
            <Text variant="medium" lineHeight="145%" spacing={0.2}>
              {step.body}
            </Text>
          </StepText>
        </StepTextColumn>
        <StepImage>
          <Image
            src={step.image}
            alt={step.alt}
            fill
            sizes="(max-width: 768px) 100vw, 50vw"
            style={{ objectFit: step.objectFit, objectPosition: 'top center' }}
          />
        </StepImage>
      </StepRow>
    ))}
  </StepsWrapper>
)

export default Steps
